<template>
  <div class="reports">
    <div class="row row-action-bar">
      <div class="col-12">
        <h4>Active Searches</h4>
      </div>
      <div
        v-if="items"
        class="col-12"
      >
        <b>{{ items && items.length }} of {{ count }} Results</b>
      </div>
    </div>
    <div class="row">
      <div
        class="col-12"
        style="margin-top: 15px;"
      > 
        <Loader
          v-if="!items"
          :style="{width: '100%'}"
        />
        
        <div
          v-else-if="items.length === 0"
          class="no-results"
        >
          <p>
            You do not have any active searches yet.
          </p>
        </div>
        <div v-else>
          <report-searches-table :items="items" />
          
          <pagination
            v-if="count > limit"
            :filtered-count="count"
            :page="page"
            :page-size="limit"
            :on-page-changed="onPageChanged"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ReportSearchesTable from '@/components/tables/ReportSearchesTable.vue';
import Pagination from '@/components/Pagination.vue';
import Loader from '@/components/Loader.vue';
import UserClient from '@/api/UserClient';

export default {
  name: 'Reports',
  components: {
    ReportSearchesTable,
    Pagination,
    Loader,
  },
  data() {
    return {
      userClient: new UserClient(this.$http),
      items: null,
      count: 0,
      page: 1,
      limit: 50,
    };
  },
  computed: {
    reportTitle() {
      return 'Active Searches';
    },
    reportSubTitle() {
      return '';
    },
  },
  mounted() {
    this.loadItems();
  },
  methods: {
    onPageChanged(page) {
      if (page !== this.page) {
        this.page = page;
        this.loadItems();
      }
    },
    loadItems() {
      this.items = null;
      this.count = 0;

      const offset = (this.page - 1) * this.limit;
      this.userClient.getMySavedSearches(this.limit, offset).then(res => {
        this.items = (res.items || []);
        this.count = res.count || 0;
      }).catch(ex => {
        this.items = [];
        this.count = 0;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.reports {
  padding-top: 45px;
  padding-bottom: 60px;
  background: #f9f9f9;

  .chart-card {
    width: 100%;
    overflow: hidden;
    padding: 30px;
    border-bottom: solid 2px $border-color;

    @media (max-width: $sm-max) {
      overflow: visible;
    }

    h3 {
      font-weight: bold;
      font-size: 20px;
      margin-bottom: 2px;
    }

    p {
      margin-bottom: 20px;
      color: rgba($black, 0.6);
    }

    .upper {
      margin-bottom: 10px;
    }

    .mid {
      max-width: 100%;
      height: 250px;
    }

    .legend {
      text-align: center;
      margin-top: 20px;

      &__item {
        .line {
          @include border-radius(10px);

          background: $blue;
          height: 2px;
          width: 40px;
          display: inline-block;
          vertical-align: top;
          padding-top: 6px;
          margin: 6px 15px 0 0;
        }

        span {
          display: inline-block;
          vertical-align: top;
          color: rgba($black, 0.67);
          font-size: 12px;
        }

        &.first {
          .line {
            background: $red;
            margin-bottom: 10px;
          }
        }
      }
    }
  }

  .left {
    width: calc(100% - 62px);
    display: inline-block;
    vertical-align: top;
  }

  .right {
    width: 62px;
    display: inline-block;
    vertical-align: top;
  }

  .fake-datepicker {
    @include border-radius($border-radius);

    display: inline-block;
    border: $default-border;
    color: rgba(black, 0.87);
    padding: 13px 20px;

    i,
    svg {
      margin-left: 15px;
    }
  }

  .row-action-bar {
    margin-top: 40px;

    b {
      line-height: 45px;
    }
  }

  .filter-btn {
    @include border-radius($border-radius);

    border: solid 1px $border-color;
    height: 52px;
    width: 52px;
    background: white;
    margin-left: 10px;
  }
}
</style>
